module.exports = __webpack_public_path__ + "img/the-world-we-make.fb9a890d.png";